module.exports = __webpack_public_path__ + "img/linkedIn.b87258bb.svg";